import { type ValidationRule } from '../../types';
import { ActionRequiredError } from '../../util/errors';
import { validateCodeExpression } from '../../util/validators';

import { CanonicalStepRuleBase } from './base';

class CaptureRule extends CanonicalStepRuleBase {
  public constructor() {
    super('steps.Capture', 'Capture');
  }

  protected validate({ args }: any): void {
    this.checkSaveEquipmentId(args);
    this.checkSaveFilepath(args);
    this.checkFilepathExpression(args);
  }

  /**
   * Validate save equipment ID.
   * Throws ActionRequiredError if missing.
   *
   * @throws {ActionRequiredError}
   */
  private checkSaveEquipmentId(args: any): void {
    if (!args.saveEquipmentId) {
      throw new ActionRequiredError({
        kind: 'invalidConfiguration',
        message: 'Save equipment ID is required',
        fieldId: 'saveEquipmentId',
      });
    }
  }

  /**
   * Validate saveFilepath presence.
   * Throws ActionRequiredError if missing.
   *
   * @throws {ActionRequiredError}
   */
  private checkSaveFilepath(args: any): void {
    if (!args.saveFilepath) {
      throw new ActionRequiredError({
        kind: 'invalidConfiguration',
        message: 'Save file path is required',
        fieldId: 'saveFilepath',
      });
    }
  }

  /**
   * Validate saveFilepath expression structure.
   * Throws ActionRequiredError if invalid.
   *
   * @throws {ActionRequiredError}
   */
  private checkFilepathExpression(args: any): void {
    validateCodeExpression(args.saveFilepath, 'saveFilepath', 'Save filepath');
  }
}

export const CaptureValidation: ValidationRule =
  new CaptureRule().toValidationRule();
